import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { CustomersEffects } from '@appStore/customers/effects/customers.effects';
import { CustomerUsersEffects } from '@appStore/customers/effects/customer-users.effects';
import { CustomerInvitationsEffects } from '@appStore/customers/effects/customer-invitations.effects';
import { CustomerRolesEffects } from '@appStore/customers/effects/customer-roles.effects';
import { CustomerManagerCompaniesEffects } from '@appStore/customers/effects/customer-manager-companies.effects';
import { CustomerAccessRequestsEffects } from '@appStore/customers/effects/customer-access-requests.effects';
import { CustomerApprovalEffects } from '@appStore/customers/effects/customer-approval.effects';

export const effects: any[] = [
  CustomersEffects,
  CustomerUsersEffects,
  CustomerInvitationsEffects,
  CustomerRolesEffects,
  CustomerManagerCompaniesEffects,
  CustomerAccessRequestsEffects,
  CustomerApprovalEffects
];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class CustomersEffectsModule {}
